<template>
  <transition name="fade">
    <div class="gs-alert-wrapper" v-show="show">
      <transition name="slide-fade">
        <div class="gs-alert-main" v-show="show">
          <div class="gs-header-box" v-if="title != ''">{{ title }}</div>
          <div class="gs-content" v-if="text">{{ text }}</div>
          <div class="gs-input">
            <input type="text" ref="input" v-model="value" @keyup.enter="handelConfirm" />
          </div>
          <div class="gs-footer-box">
            <div class="gs-alert-button" @click="handelCancel">
              {{ cancelText }}
            </div>
            <div
              class="gs-alert-button gs-alert-confirm"
              @click="handelConfirm"
            >
              {{ confirmText }}
            </div>
          </div>
        </div>
      </transition>
    </div>
  </transition>
</template>
<script>
export default {
  name: "gsAlert",
  data() {
    return {
      title: "",
      text: "",
      value: "",
      promise: null,
      show: false,
      cancelText: "",
      confirmText: "",
    };
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
          this.$refs.input.focus();
      }, 500);
    });
  },
  methods: {
    init() {
      this.show = true;
      return new Promise((resolve, reject) => {
        this.promise = { resolve, reject };
      });
    },
    handelCancel() {
      // 取消
      this.promise.reject();
      this.destroyVm();
    },
    handelConfirm() {
      // 确定
      this.promise.resolve(this.value);
      this.destroyVm();
    },
    destroyVm() {
      // 销毁
      this.show = false;
      setTimeout(() => {
        this.$destroy(true); // 完全销毁一个实例。清理它与其它实例的连接，解绑它的全部指令及事件监听器
        this.$el && this.$el.parentNode.removeChild(this.$el); // 删除dom
      }, 500);
    },
  },
};
</script>
<style lang="scss" scoped>
.gs-alert-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 99999;
  background: rgba($color: #000000, $alpha: 0.3);
  .gs-alert-main {
    width: 296px;
    background: #ffffff;
    border-radius: 5px;
    overflow: hidden;
    .gs-header-box {
      padding: 0 20px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      font-size: 16px;
      color: #222222;
      box-sizing: border-box;
    }
    .gs-content {
      padding: 10px 24px;
      line-height: 14px;
      font-size: 14px;
      color: #999;
      box-sizing: border-box;
      text-align: center;
    }
    .gs-input {
      width: 80%;
      height: 35px;
      margin: 0 auto 15px;
      input {
        width: 100%;
        height: 100%;
        border: 1px solid #eee;
        border-radius: 4px;
        padding: 0 15px;
        box-sizing: border-box;
        outline: none;
      }
    }
    .gs-footer-box {
      display: flex;
      height: 48px;
      border-top: 1px solid;
      border-color: #eee;
      .gs-alert-button {
        height: 48px;
        width: 0;
        flex: 1;
        text-align: center;
        line-height: 48px;
        font-size: 16px;
        color: #999;
        border-right: 1px solid;
        border-color: #eee;
        user-select: none;
        cursor: pointer;
        &:last-of-type {
          border: none;
        }
        &.gs-alert-confirm {
          color: #eb413d;
        }
      }
    }
  }
}
</style>
